<template>
    <div id="app">
        <router-view></router-view>
    </div>
</template>

<script>

    export default {
        name: 'app',
        data: {
            name: '',
            age: 0
        },
    }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/App.vue